var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgApprovedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.42429 0.575638C9.6586 0.809953 9.6586 1.18985 9.42429 1.42417L3.80002 7.04843L0.57576 3.82417C0.341446 3.58985 0.341446 3.20995 0.57576 2.97564C0.810075 2.74132 1.18997 2.74132 1.42429 2.97564L3.80002 5.35137L8.57576 0.575638C8.81008 0.341324 9.18997 0.341324 9.42429 0.575638Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovedIcon);
export default __webpack_public_path__ + "static/media/approvedIcon.b439fe8789f57baf57ae32890ac4c499.svg";
export { ForwardRef as ReactComponent };